import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalComponentsModule} from '../../../global-components/global-components.module';
import {SharedComponentsModule} from '../shared-components/shared-components.module';
import {SkillHomeControllerComponent} from './skill-home-controller.component';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [
        SkillHomeControllerComponent
    ],
    exports: [
        SkillHomeControllerComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        GlobalComponentsModule,
        SharedComponentsModule,
    ]
})
export class SkillHomeModule {}
